export default {
  heading: "Arial, serif",
  sans: "'Libre Franklin', sans-serif",
  mono: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  body: "Mulish, sans-serif",
};
